module.exports = __webpack_public_path__ + "static/incentives-65ab25e19230a4f064210b7938cfa855.jpg";